import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import dayjs from 'dayjs';
import dayjsSvLocale from 'dayjs/locale/sv';
import { ArticleDate, ArticleDateProps } from './ArticleDate';
import { ArticleDateUpdatedProps } from './ArticleDate.Updated';

export interface StandaloneArticleDateProps extends StandaloneComponentProps {
  publishedDatetime?: string;
  updatedDatetime?: string;
  format?: string;
  options?: ArticleDateProps & {
    $updatedDate?: ArticleDateUpdatedProps;
  };
}

export const StandaloneArticleDate: StandaloneComponent<StandaloneArticleDateProps> = ({
  publishedDatetime,
  updatedDatetime,
  format,
  options,
}) => {
  const { $updatedDate: updatedDateProps, ...baseProps } = options ?? {};

  const dateFormat = format || 'D MMMM YYYY';

  const formattedPublishDate = dayjs(publishedDatetime).locale(dayjsSvLocale).format(dateFormat);
  const formattedUpdateDate = dayjs(updatedDatetime).locale(dayjsSvLocale).format(dateFormat);

  return (
    <>
      <span>
        <ArticleDate {...baseProps} suppressHydrationWarning>
          {formattedPublishDate}
        </ArticleDate>
        &#160;
      </span>

      {updatedDatetime && (
        <ArticleDate.UpdatedDate {...updatedDateProps} suppressHydrationWarning>
          {`UPPDATERAD ${formattedUpdateDate}`}
        </ArticleDate.UpdatedDate>
      )}
    </>
  );
};
